function productVariantRadioInit($, $form) {
    const $variationRadiosInputs = $form.find('.js-variation-radios input');
    let activeOption = $variationRadiosInputs
        .filter(':checked')
        .first()
        .get(0)
        || null;

    $variationRadiosInputs.on('click', function() {
        if (this === activeOption) {
            $form.trigger('reset_data');
        } else {
            activeOption = this;
        }
    });

    $variationRadiosInputs.on('change', () => {
        $variationRadiosInputs.filter(':checked').each((index, element) => {
            const $el = $(element);
            const name = $el.attr('name');
            const value = $el.attr('value');
            $(`select[name="${name}"]`).val(value).trigger('change');
        });
    });

    $form.on('reset_data', () => {
        $variationRadiosInputs.prop('checked', false);
        activeOption = null;
    })

    $form.on('woocommerce_update_variation_values', () => {
        $variationRadiosInputs.each((index, element) => {
            const $el = $(element);
            const name = $el.attr('name');
            const value = $el.attr('value');
            $el
                .prop('disabled', !$(`select[name="${name}"] option[value="${value}"]`)
                    .is(':enabled'));
        });
    });
}

export function variationFormLoader($) {
    $('.variations_form.cart').each((index, form) => {
        productVariantRadioInit($, $(form));
    });
}
